<script lang="ts">

export let id = "";

import { link } from "svelte-routing";
import { fetchPeople } from "../services/people";
    import { fade } from "svelte/transition";
    import { quintOut } from "svelte/easing";

// Fetch person's data from people.json by filtering through it until matching id
const personDataFetch = new Promise(async (resolve: (data: any) => void) => {
    const data = await fetchPeople();
    
    // Filter out person with the matching id
    let filtered = data.filter(item => item.id == id);

    // First item in filtered list (best match)
    resolve((filtered.length >= 1) ? filtered[0] : null);
});

</script>




<div class="top-background" style="background-image:url(../images/backgrounds/people.jpg);">
    <h1 class="page-title">The LCML Team</h1>
</div>

<section id="people">
    <div class="content">
        <a class="back-button" href="/people" use:link>Go Back</a>
        {#await personDataFetch}
            <!-- Loading Animatin -->
            <div class="loading-cube-grid">
                <div class="sk-cube sk-cube1"></div>
                <div class="sk-cube sk-cube2"></div>
                <div class="sk-cube sk-cube3"></div>
                <div class="sk-cube sk-cube4"></div>
                <div class="sk-cube sk-cube5"></div>
                <div class="sk-cube sk-cube6"></div>
                <div class="sk-cube sk-cube7"></div>
                <div class="sk-cube sk-cube8"></div>
                <div class="sk-cube sk-cube9"></div>
            </div>
        {:then person}
            <!-- Check that person exists (data isnt null) -->
            <div in:fade={{ easing: quintOut, duration: 1000 }}>
                {#if (person && person !== null)}
                    <!-- Name, position, and primary buttons -->
                    <div class="top-wrapper">
                        <div class="basic-info">
                            <h1>{ @html person.name }</h1>
                            <h4>{ @html person.position }</h4>
                        </div>
                        {#if person.googleScholarLink}
                            <a href="{person.googleScholarLink}" target="_blank" class="action-button">Google Scholar</a>
                        {/if}
                        {#if person.email}
                            <a href="mailto:{person.email}" target="_blank" class="action-button">Email</a>
                        {/if}
                    </div>

                    <div class="flex-wrapper">
                        <!-- Profile picture -->
                        <div class="flex-column first">
                            {#if person.imageSrc}
                                <img src={person.imageSrc} alt="{person.name}'s profile photo" class="profile-picture"/>
                            {:else}
                                <img src="/images/people/default.jpg" alt="{person.name}'s default profile photo" class="profile-picture"/>
                            {/if}
                        </div>

                        <!-- Details with categories -->
                        <div class="flex-column secondary">
                            {#each person.details as detail}
                                <div class="detail-wrapper">
                                    <h3 class="subtitle">{@html detail.title}</h3>
                                    <!-- Check if detail is a list of bullet points or just text -->
                                    {#if detail.text}
                                        <p>{@html detail.text}</p>
                                    {:else if detail.list && Array.isArray(detail.list)}
                                        <ul>
                                            {#each detail.list as bullet}
                                                <li>{@html bullet}</li>
                                            {/each}
                                        </ul>
                                    {/if}
                                </div>
                            {/each}
                        </div>
                    </div>
                {:else}
                    <div class="no-results-container">
                        <img src="/images/icons/no-results.png" alt="no results">
                        <h3>Sorry, this person doesn't exist.</h3>
                    </div>
                {/if}
            </div>
        {/await}
        
    </div>
</section>




<style lang="sass">

@import "../consts.sass"
@include page-header()
@include action-button()
@include loading-spinner()
@include no-search-results-text()

.back-button
    color: $color_secondary
    text-decoration: none
    font-size: 1.2rem
    background-image: url(../images/icons/left-arrow.png)
    background-repeat: no-repeat 
    background-position: 0px 0px
    background-size: 1.3em
    padding-left: 1.8em

    &:hover
        text-decoration: underline

.content
    padding: 3em 2em
    box-sizing: border-box

    .loading-spinner
        margin: 4em 0
        display: block

    @media only screen and (min-width: 1200px) 
        padding-right: 10vw
        padding-left: 10vw

    .top-wrapper .basic-info
        margin: 1.5em 0

        h4
            margin-top: 0
            margin-bottom: 5px

    .flex-wrapper
        margin-top: 3rem
        display: flex
        flex-direction: row
        justify-content: flex-start

        img.profile-picture
            border-radius: 0.2rem

        h3
            font-weight: normal

        @media only screen and (max-width: 1200px) 
            flex-direction: column
            flex-flow: wrap

            img.profile-picture
                width: 22em

            .flex-column.secondary
                margin-top: 2em
        
        @media only screen and (min-width: 1200px) 
            img.profile-picture
                max-width: 22em
            
            .flex-column.secondary
                margin-left: 5em
                    



</style>